import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { useTheme } from '@nexelem/deprecated-theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';

type InputHelperTextProps = {
  label: string | ReactNode;
  showIcon?: boolean;
  isJumbo?: boolean;
};

export const InputHelperText = ({ label, showIcon, isJumbo = false }: InputHelperTextProps) => {
  const {
    palette: { getColor },
    client: {
      inputs: {
        defaultColors: {
          defaultState: { labelColor },
        },
      },
    },
  } = useTheme();

  return (
    <div className="flex items-center gap-2 pb-2 pl-2" style={{ color: getColor(labelColor) }}>
      {showIcon && <FontAwesomeIcon className="helper-text-icon" icon={faCircleInfo} />}
      <span
        className={clsx(isJumbo ? 'text-t20-sb' : 'text-t14-sb', 'helper-text')}
        style={{ color: getColor(labelColor) }}
      >
        {label}
      </span>
    </div>
  );
};
